// Level system constants & helpers (Phase 1.8)

export const LEVELS = [
  { level: 1, title: '新手', stars: '★', minPoints: 0 },
  { level: 2, title: '揪咖', stars: '★★', minPoints: 100 },
  { level: 3, title: '熱血玩家', stars: '★★★', minPoints: 300 },
  { level: 4, title: '揪團達人', stars: '★★★★', minPoints: 800 },
  { level: 5, title: '傳奇隊長', stars: '★★★★★', minPoints: 2000 },
];

// Returns { level, title, stars, minPoints, nextLevel, pointsToNext, progress }
export function getLevelInfo(totalPoints) {
  const points = Math.max(0, totalPoints || 0);

  let current = LEVELS[0];
  for (const lv of LEVELS) {
    if (points >= lv.minPoints) current = lv;
  }

  const nextLevel = LEVELS.find((lv) => lv.level === current.level + 1) || null;
  const pointsToNext = nextLevel ? nextLevel.minPoints - points : 0;
  const progress = nextLevel
    ? Math.min(1, (points - current.minPoints) / (nextLevel.minPoints - current.minPoints))
    : 1;

  return { ...current, points, nextLevel, pointsToNext, progress };
}
